// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.1/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkbox-wrapper[data-v-8e98ed46] {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n.checkbox-wrapper input[type='checkbox'][data-v-8e98ed46] {\n  margin-top: 0.35rem;\n  flex-shrink: 0;\n}\n.checkbox-wrapper label[data-v-8e98ed46] {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
